export default __webpack_public_path__ + "static/media/Colts.e07d90e9.png";